if (!customElements.get('accordion-element')) {
  class Accordion extends HTMLElement {
    constructor() {
      super()
      this.controlsId = this.getAttribute('controls-id')
      this.isActive = this.getAttribute('is-active') || false
      this.title = this.getAttribute('title')
      this.content = this.innerHTML
      this.summaryMarkup = `
        <summary>
          <button class="js-accordion-toggle accordion__title p1 block relative" aria-expanded="${this.isActive}" aria-controls="${this.controlsId}">
            ${this.title}
            <span class="accordion__title__icon"></span>
          </button>
        </summary>`

      this.innerHTML = `
        <div class="accordion__inner js-accordion ${
          !this.title ? 'not-accordion' : ''
        } ${this.isActive ? 'is-active' : ''}">
          ${this.title ? this.summaryMarkup : ''}
          <div class="accordion__body js-accordion-body">
            <div class="accordion__body__content js-accordion-content">
              ${this.content}
            </div>
          </div>
        </div>
      `

      //selectors
      this.accordion = this.querySelector('.js-accordion')
      this.toggleBtn = this.querySelector('.js-accordion-toggle')
      this.accordionBody = this.querySelector('.js-accordion-body')
      this.contentSelector = this.querySelector('.js-accordion-content')
      this.toggleBtn?.addEventListener('click', () => {
        this.toggleAccordion()
      })
      this.accordion.parentNode.classList.add('accordion')
      this.additionalClasses = this.getAttribute('additional-classes')
        ? this.accordion.parentNode.classList.add(
            this.getAttribute('additional-classes')
          )
        : ''
    }

    calcHeight() {
      const styles = { maxHeight: 0, visibility: 'hidden' }

      if (!this.isActive) {
        Object.assign(this.accordionBody.style, styles)

        return
      }

      styles.maxHeight =
        this.contentSelector.getBoundingClientRect().height + 'px'
      styles.visibility = 'visible'

      Object.assign(this.accordionBody.style, styles)
      this.toggleSiblings(this)
    }

    toggleSiblings(expandingAccordion) {
      const activeAccordions = Array.from(
        expandingAccordion.parentNode.childNodes
      )
      activeAccordions.map((accordion, index) => {
        if (accordion.isActive && accordion !== expandingAccordion) {
          accordion.toggleAccordion()
          return
        }
      })
    }

    toggleAccordion() {
      this.isActive = !this.isActive
      this.accordion.classList.toggle('is-active')
      this.toggleBtn.setAttribute('aria-expanded', this.isActive)

      this.calcHeight()
    }

    connectedCallback() {
      setTimeout(() => {
        this.calcHeight()
      }, 500)
    }
  }

  customElements.define('accordion-element', Accordion)
}
